import { Link } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

export default function NotFound() {
  return (
    <div className="bg-ink text-white min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 mx-auto w-full max-w-3xl px-5 md:px-8 pt-40 pb-24 flex flex-col items-start justify-center" data-testid="not-found-page">
        <p className="font-display text-7xl md:text-9xl font-extrabold text-brand/30">404</p>
        <h1 className="mt-4 font-display text-3xl md:text-5xl font-bold uppercase tracking-tighter">
          Seite nicht gefunden.
        </h1>
        <p className="mt-4 text-sm md:text-base text-white/60 max-w-md">
          Die gesuchte Seite existiert nicht oder wurde verschoben. Hier geht es zurück zu unseren Leistungen rund um Haus, Grundstück und Immobilie.
        </p>
        <Link
          data-testid="not-found-home-link"
          to="/"
          className="mt-8 rounded-full bg-brand px-8 py-4 text-sm font-bold tracking-wider text-black hover:bg-brand-bright transition-colors duration-300"
        >
          ZUR STARTSEITE
        </Link>
      </main>
      <Footer />
    </div>
  );
}
